var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 16.6668H4.16667C3.72464 16.6668 3.30072 16.4912 2.98816 16.1787C2.67559 15.8661 2.5 15.4422 2.5 15.0002V7.50016C2.5 7.05814 2.67559 6.63421 2.98816 6.32165C3.30072 6.00909 3.72464 5.8335 4.16667 5.8335H15.8333C16.2754 5.8335 16.6993 6.00909 17.0118 6.32165C17.3244 6.63421 17.5 7.05814 17.5 7.50016V15.0002C17.5 15.4422 17.3244 15.8661 17.0118 16.1787C16.6993 16.4912 16.2754 16.6668 15.8333 16.6668Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7487 11.6668C13.6382 11.6668 13.5322 11.6229 13.4541 11.5448C13.3759 11.4667 13.332 11.3607 13.332 11.2502C13.332 11.1397 13.3759 11.0337 13.4541 10.9555C13.5322 10.8774 13.6382 10.8335 13.7487 10.8335C13.8592 10.8335 13.9652 10.8774 14.0433 10.9555C14.1215 11.0337 14.1654 11.1397 14.1654 11.2502C14.1654 11.3607 14.1215 11.4667 14.0433 11.5448C13.9652 11.6229 13.8592 11.6668 13.7487 11.6668Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5.8333V4.66913C14.9999 4.41372 14.9412 4.16174 14.8282 3.93265C14.7153 3.70356 14.5512 3.50349 14.3487 3.34789C14.1461 3.1923 13.9105 3.08533 13.66 3.03527C13.4096 2.9852 13.151 2.99336 12.9042 3.05913L3.7375 5.5033C3.38254 5.59789 3.06878 5.8071 2.84499 6.0984C2.6212 6.38971 2.49992 6.74679 2.5 7.11413V7.49997",
    stroke: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/Wallet.e0a0122a.svg";
export { ForwardRef as ReactComponent };